import { render, staticRenderFns } from "./Parceria_Sintacluns.vue?vue&type=template&id=1ed33ca4"
import script from "./Parceria_Sintacluns.vue?vue&type=script&lang=js"
export * from "./Parceria_Sintacluns.vue?vue&type=script&lang=js"
import style0 from "./Parceria_Sintacluns.vue?vue&type=style&index=0&id=1ed33ca4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports